import { withErrorBoundary } from '../dependencies';

import DateRangePicker from '../components/DateRangePicker';

export default withErrorBoundary(DateRangePicker);
